import React from 'react';
import { FileMedia } from '../../../../ui';
import styled from 'styled-components';

const Container = styled.div`
  margin-bottom: 20px;
`;

const TaskHeaderMedia = ({ data, themeColor }) => {
  return (
    <Container>
      <FileMedia files={data} themeColor={themeColor} />
    </Container>
  );
};

export default TaskHeaderMedia;
